import { useEffect, useState } from 'react';

export const useWindowSize = () => {
  const [size, setSize] = useState<{
    readonly width: number | null;
    readonly height: number | null;
  }>({ width: null, height: null });
  useEffect(() => {
    const resize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  return { size };
};
